export enum SurgicalOrderGuideAuthorizationEnum {
  ANALYSIS = 'ANALYSIS',
  AUTHORIZED = 'AUTHORIZED',
  FAILURE = 'FAILURE',
  DENIED = 'DENIED',
  CANCELED = 'CANCELED',
  PENDENCY = 'PENDENCY',
  PARTIALLY_AUTHORIZED = 'PARTIALLY_AUTHORIZED',
  PRE_AUTHORIZED = 'PRE_AUTHORIZED',
  NEGOTIATION = 'NEGOTIATION',
  REQUESTED = 'REQUESTED',
  NOT_REQUIRED_AUTHORIZATION = 'NOT_REQUIRED_AUTHORIZATION'
}

export interface LoadSurgicalOrderGuideAuthorization {
  load: (
    surgical_order_guide_id: number
  ) => Promise<LoadSurgicalOrderGuideAuthorization.Model>
}

export namespace LoadSurgicalOrderGuideAuthorization {
  export type Model = {
    data: {
      data: SurgicalOrderGuideAuthorization[]
    }
  }
}

export type SurgicalOrderGuideAuthorization = {
  authorization_details_guide_id: number
  status?: SurgicalOrderGuideAuthorizationEnum
  protocol: number
  password: string
  validate_password: string
  is_active: boolean
  reason: string
  user: {
    user_id: number
    name: string
    last_name: string
  }
  guide: {
    surgical_order_guide_id: number
  }
  created_at: string
  updated_at: string
}

// export namespace LoadSurgicalOrderGuideAuthorization {
//   export type Model = {
//     data: {
//       data: {
//         authorization_details_guide_id: number
//         status: SurgicalOrderGuideAuthorizationEnum
//         protocol: number
//         password: string
//         validate_password: string
//         is_active: boolean
//         user: {
//           user_id: number
//           name: string
//           last_name: string
//         }
//         guide: {
//           surgical_order_guide_id: number
//         }
//         created_at: string
//         updated_at: string
//       }
//     }
//   }
// }
